import permissions from '../services/Permissions';

export default {
    props: {
        permissionsAccess: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getPermission(permission) {
            return permissions.getPermission(this.permissionsAccess, permission);
        },
    },
};
